module.exports = __webpack_public_path__ + "static/media/Exhibition_web.2e7ca2a1.jpg";